<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title p-8">
                  <h4><img src="@/assets/images/intro/intro_logo.png" alt="FilledU"/></h4><br>
                  <div class="vx-row p-5">
                    <h4 class="text-primary">{{title}} </h4> &nbsp;
                    <h4 class="mb-4">클래스에 가입하세요.</h4>
                  </div>
                  <p> PIN 코드를 입력하여 함께하세요 :)</p>
                </div>
                <vs-input type="email" label-placeholder="PIN 코드" v-model="pinNum" class="w-full mb-5" />
                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8" @click="submit">확인</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pinNum: '',
      inviteId: 0,
      title:'',
      category: false
    }
  },
  computed: {
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    }
  },
  created(){
    var val = this.$route.params.workspaceId.split('&')
    this.inviteId = val[0].split('=')[1]
    this.title = val[1].split('=')[1]
    this.category = val[2].split('=')[1] == '[Project]' ? true : false

    if(localStorage.getItem("filleduToken") || sessionStorage.getItem("filleduToken")){
      this.$store.dispatch('auth/fetchAccessToken')
      .catch(error => {
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.$router.push('/pages/login')
      })
    }else{
      this.$router.push('/pages/login')
    }
  },
  methods: {
    submit() {
      if(!this.category){
        this.$store.dispatch('auth/inviteAccept', {category:this.category, id:this.inviteId, pin_number:Number(this.pinNum)})
        .then(()=>{
          this.$router.push('/apps/space/dashboard/main/'+this.inviteId)
        }) .catch(()=> {
          this.$vs.notify({
            title: '에러',
            text: "pin code를 확인해 주세요.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    }
  }
}
</script>
